import { getAllByIndex, putRecord, OFFLINE_DB_VERSION } from './db';
import { getDeviceId } from './device';
import { getConnectivitySnapshot } from './connectivity';
import { inspectStorageSafety } from './storageSafety';
import type { ClientHealthRecord, OutboxCommand } from './types';
import { apiClient } from '../services/api';
import { backendUsable, probeConnectivity } from './connectivity';
import { detectCapabilities } from './capabilities';

export async function collectClientHealth(userId?: string | null): Promise<ClientHealthRecord> {
  const statuses: OutboxCommand['status'][] = ['PENDING', 'READY', 'SYNCING', 'FAILED_RETRYABLE', 'CONFLICT'];
  let pending = 0;
  for (const status of statuses) {
    const rows = await getAllByIndex<OutboxCommand>('outbox_commands', 'byStatusPriority', IDBKeyRange.bound([status, 'P0', 0], [status, 'P4', Number.MAX_SAFE_INTEGER]));
    if (!userId) pending += rows.length;
    else pending += rows.filter(row => row.user_id === userId).length;
  }
  const storage = await inspectStorageSafety(false);
  const connectivity = getConnectivitySnapshot();
  const authState: ClientHealthRecord['auth_state'] = connectivity.state === 'AUTH_REQUIRED' ? 'AUTH_REQUIRED' : connectivity.api_reachable && connectivity.authenticated ? 'ONLINE_AUTHENTICATED' : 'UNKNOWN';
  const health: ClientHealthRecord = {
    id: 'current',
    device_id: getDeviceId(),
    app_version: (import.meta as any).env?.VITE_APP_VERSION || '1.5.0-web',
    sw_version: localStorage.getItem('coconnect_sw_version'),
    db_version: OFFLINE_DB_VERSION,
    last_sync_at: localStorage.getItem('coconnect_last_sync_at'),
    pending_count: pending,
    storage_state: storage.state,
    persistence_state: storage.persistence_state,
    auth_state: authState,
    connectivity_state: connectivity.state,
    last_error_code: localStorage.getItem('coconnect_last_offline_error'),
    updated_at: new Date().toISOString(),
  };
  await putRecord('client_health', health);
  return health;
}


export async function reportClientHealth(userId?: string | null): Promise<boolean> {
  const connectivity = await probeConnectivity();
  if (!backendUsable(connectivity.state) || connectivity.authenticated === false) return false;
  const health = await collectClientHealth(userId);
  await apiClient.post('/offline/health', { ...health, capabilities: detectCapabilities() });
  return true;
}
